import styled from "styled-components";
import { Box } from "@mui/material";

export const SectionsConfigContainer = styled(Box)`
	margin-top: 20px;

	display: flex;
	flex-direction: column;
	gap: 10px;
	.title {
		font-family: var(--poppins), sans-serif;
		font-size: 22px;
		font-weight: bold;
	}
	.config {
		display: flex;
		justify-content: space-between;
		padding: 5px 10px;
		box-shadow: 0 0 1px 1px #d9d9d9;
		border-radius: 10px;
		align-items: center;
		.name {
			font-family: var(--poppins), sans-serif;
		}
		.visibility {
			max-height: 50px;
			max-width: 50px;
		}
	}
`;
